import { STATIONERY_GRID_PREVIEW_ASPECT_WH } from '~~/layers/base/constants/stationeryGridPreviewAspect'

/**
 * Width÷height for grid tiles and CDN `scale-down` bounds.
 *
 * Uses `referenceCanvasPx` when present (matches the preview PNG). Does **not** use
 * `paperSizeInches` — physical trim is often portrait while on-screen previews are
 * landscape (e.g. 300×200). Otherwise {@link STATIONERY_GRID_PREVIEW_ASPECT_WH} (3∶2).
 */
export function stationeryPreviewAspectWidthOverHeightFromMeta(
    meta: Record<string, unknown> | undefined,
    fallback: number = STATIONERY_GRID_PREVIEW_ASPECT_WH
): number {
    if (!meta || typeof meta !== 'object') return fallback

    const canvas = meta.referenceCanvasPx as { width?: unknown; height?: unknown } | undefined
    if (
        canvas &&
        typeof canvas.width === 'number' &&
        typeof canvas.height === 'number' &&
        canvas.width > 0 &&
        canvas.height > 0
    ) {
        return canvas.width / canvas.height
    }

    return fallback
}
